var carousel01 = null;
var carousel03 = null;
var carousel04 = null;
var carousel05 = null;
$(function () {
  // carousel
  if ($("header .main").length > 0) {
    $("header .main").each(function () {
      $(".slide", $(this)).bxSlider({
        mode: "fade",
        pager: true,
        controls: true,
        pause: 5000, // スライドの表示時間
        auto: true,
        onSliderLoad: function () {
          $("header .main .slide").animate({ opacity: 1 });
        },
      });
    });
  }
  if ($("#contents .carousel01").length > 0) {
    $("#contents .carousel01").each(function () {
      // shuffle
      var size = $(".panel:eq(0) a", $(this)).length;
      var arr = [];
      $(".panel a", $(this)).each(function () {
        arr.push($(this));
      });
      arr.sort(function () {
        return Math.random() - Math.random();
      });
      $(".panel", $(this)).empty();
      for (i = 0; i < arr.length; i++) {
        $(".panel", $(this))
          .eq(Math.floor(i / size))
          .append(arr[i]);
      }
      carousel01 = $(".slide", $(this)).bxSlider({
        adaptiveHeight: true,
        pager: false,
        auto: true,
        pause: 8000,
        nextText: "次の12件",
        prevText: "前の12件",
        slideMargin: 10,
      });
    });
  }

  if ($("#contents .carousel03").length > 0) {
    $("#contents .carousel03").each(function () {
      // shuffle
      var size = $(".panel:eq(0) a", $(this)).length;
      var arr = [];
      $(".panel a", $(this)).each(function () {
        arr.push($(this));
      });
      $(".panel", $(this)).empty();
      for (i = 0; i < arr.length; i++) {
        $(".panel", $(this))
          .eq(Math.floor(i / size))
          .append(arr[i]);
      }
      carousel03 = $(".slide", $(this)).bxSlider({
        adaptiveHeight: true,
        pager: false,
        auto: true,
        pause: 8000,
        nextText: "次の4件",
        prevText: "前の4件",
        slideMargin: 10,
      });
    });
  }

  if ($("#contents .carousel04").length > 0) {
    $("#contents .carousel04").each(function () {
      // shuffle
      var size = $(".panel:eq(0) a", $(this)).length;
      var arr = [];
      $(".panel a", $(this)).each(function () {
        arr.push($(this));
      });
      $(".panel", $(this)).empty();
      for (i = 0; i < arr.length; i++) {
        $(".panel", $(this))
          .eq(Math.floor(i / size))
          .append(arr[i]);
      }
      carousel04 = $(".slide", $(this)).bxSlider({
        adaptiveHeight: true,
        pager: false,
        auto: true,
        pause: 8000,
        nextText: "次の4件",
        prevText: "前の4件",
        slideMargin: 10,
      });
    });
  }

  if ($("#contents .carousel05").length > 0) {
    $("#contents .carousel05").each(function () {
      // shuffle
      var size = $(".panel:eq(0) a", $(this)).length;
      var arr = [];
      $(".panel a", $(this)).each(function () {
        arr.push($(this));
      });
      $(".panel", $(this)).empty();
      for (i = 0; i < arr.length; i++) {
        $(".panel", $(this))
          .eq(Math.floor(i / size))
          .append(arr[i]);
      }
      carousel05 = $(".slide", $(this)).bxSlider({
        adaptiveHeight: true,
        pager: false,
        auto: true,
        pause: 8000,
        nextText: "次の4件",
        prevText: "前の4件",
        slideMargin: 10,
      });
    });
  }

  if ($("#contents .carousel02").length > 0) {
    $("#contents .carousel02").each(function () {
      $(".slide", $(this)).bxSlider({
        pager: false,
        auto: true,
        minSlides: 2,
        maxSlides: 7,
        slideMargin: 1,
      });
    });
  }

  // banner01
  if ($("#contents .adSpace01").length > 0) {
    $("#contents .adSpace01").each(function () {
      $(".slide", $(this)).bxSlider({
        /*mode: 'fade',*/
        //				speed: 700,
        speed: 1400,
        pager: false,
        controls: false,
        auto: true,
      });
    });
  }

  // banner02
  if ($("#contents .adSpace02").length > 0) {
    $("#contents .adSpace02").each(function () {
      $(".slide", $(this)).bxSlider({
        /*mode: 'fade',*/
        //				speed: 700,
        speed: 1400,
        pager: false,
        controls: false,
        auto: true,
      });
    });
  }

  // resize window
  resizeWindow();
  var timer = false;
  $(window).resize(function () {
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      resizeWindow();
    }, 200);
  });

  // sidemenu
  $("#sidemenu .menuSP").click(function () {
    if ($("#sidemenu .menu").css("display") == "none") {
      $("#sidemenu .dropdown, #sidemenu .dropdown > div").hide();
      $("#sidemenu .menu").slideDown();
    } else {
      $("#sidemenu .dropdown, #sidemenu .dropdown > div").hide();
      $("#sidemenu .menu").slideUp();
    }
  });
  $("#sidemenu .menu .close a").click(function () {
    $("#sidemenu .menu").slideUp();
    return false;
  });
  $('#sidemenu .menu a[href*="#"]').click(function () {
    $("#sidemenu .menu a").removeClass("active");
    var windowWidth = $(window).width();
    if (windowWidth < 640) {
      $("#sidemenu .menu").hide(); //スマホだけで効くようにする
    }
    $("#sidemenu .dropdown, #sidemenu .dropdown > div").hide();
    var attr_class = $(this).attr("class");
    if ($("#sidemenu .dropdown div").hasClass(attr_class)) {
      $(this).addClass("active");
      $("#sidemenu .dropdown, #sidemenu .dropdown ." + attr_class).fadeIn();
    }
    return false;
  });
  $("#sidemenu .dropdown .close a").click(function () {
    $("#sidemenu .menu a").removeClass("active");
    $("#sidemenu .dropdown, #sidemenu .dropdown > div").fadeOut();
    return false;
  });

  //16.12.12 追加
  $("#spMenu .menuSP").click(function () {
    if ($("#spMenu .menu").css("display") == "none") {
      $("#sidemenu .dropdown, #sidemenu .dropdown > div").hide();
      $("#spMenu .menu").slideDown();
    } else {
      $("#sidemenu .dropdown, #sidemenu .dropdown > div").hide();
      $("#spMenu .menu").slideUp();
    }
  });
  $("#spMenu .menu .close a").click(function () {
    $("#spMenu .menu").slideUp();
    return false;
  });
  $('#spMenu .menu a[href*="#"]').click(function () {
    $("#spMenu .menu a").removeClass("active");
    var windowWidth = $(window).width();
    if (windowWidth < 640) {
      $("#spMenu .menu").hide(); //スマホだけで効くようにする
    }
    $("body,html").animate({ scrollTop: 0 }, 500);

    $("#sidemenu .dropdown, #sidemenu .dropdown > div").hide();
    var attr_class = $(this).attr("class");
    if ($("#sidemenu .dropdown div").hasClass(attr_class)) {
      $(this).addClass("active");
      $("#sidemenu .dropdown, #sidemenu .dropdown ." + attr_class).fadeIn();
    }
    return false;
  });
  SmoothScroll();
});

//16.12.12 追加ここまで

function resizeWindow() {
  if ($("#sidemenu").css("text-align") == "left") {
    $("#sidemenu .menu").hide();
    $("#sidemenu").css("position", "relative");
  } else {
    $("#sidemenu .menu").show();
    if ($(window).height() > $("#sidemenu .inner").height()) {
      $("#sidemenu").css("position", "fixed");
    } else {
      $("#sidemenu").css("position", "absolute");
    }
  }

  if ($("#contents .carousel01").length > 0) {
    $("#contents .carousel01 .panel").each(function () {
      $("a", $(this)).tile(4);
    });
    carousel01.reloadSlider();
  }

  if ($("#contents .carousel03").length > 0) {
    $("#contents .carousel03 .panel").each(function () {
      $("a", $(this)).tile(4);
    });
    carousel03.reloadSlider();
  }
  if ($("#contents .carousel04").length > 0) {
    $("#contents .carousel04 .panel").each(function () {
      $("a", $(this)).tile(4);
    });
    carousel04.reloadSlider();
  }
  if ($("#contents .carousel05").length > 0) {
    $("#contents .carousel05 .panel").each(function () {
      $("a", $(this)).tile(4);
    });
    carousel05.reloadSlider();
  }
}

function SmoothScroll(classname, duration, height_index) {
  if (classname == null) classname = "scroll";
  if (duration == null) duration = 1000;
  if (height_index == null) height_index = 0;

  $("a." + classname + '[href*="#"]:not([href="#"])').click(function () {
    if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      if (target.length) {
        $("html,body").animate(
          {
            scrollTop: target.offset().top + height_index,
          },
          duration
        );
        return false;
      }
    }
  });
}

$(function () {
  var timer = false;
  $(window).resize(function () {
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      if ($(window).width() >= 640) {
        $("#sidemenu .dropdown h4").next("div").removeAttr("style");
      }
    }, 200);
  });
  $("#sidemenu .dropdown h4").click(function () {
    if ($(window).width() < 640) {
      $(this).next("div").slideToggle();
      $(this).toggleClass("open");
    }
  });
  $(".addOther h4").click(function () {
    if ($(window).width() < 640) {
      $(this).next("div").slideToggle();
      $(this).toggleClass("open");
    }
  });
});

$(function () {
  var timer = false;
  $(window).resize(function () {
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      if ($(window).width() >= 640) {
        $("#sidemenu .dropdown .areaSearch01 h4.areaTit01").next("p").removeAttr("style");
        $(this).toggleClass("open");
      }
    }, 200);
  });
  $("#sidemenu .dropdown .areaSearch01 h4.areaTit01").click(function () {
    if ($(window).width() < 640) {
      $(this).next("p").slideToggle();
    }
  });
});

$(function () {
  var timer = false;
  $(window).resize(function () {
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      if ($(window).width() >= 640) {
        $(".checkList01 .areaSearch01 h4.areaTit01").next("p").removeAttr("style");
      }
    }, 200);
  });
  $(".checkList01 .areaSearch01 h4.areaTit01").click(function () {
    if ($(window).width() < 640) {
      $(this).next("p").slideToggle();
      $(this).toggleClass("open");
    }
  });
});

$(function () {
  var timer = false;
  $(window).resize(function () {
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      if ($(window).width() >= 640) {
        $(".dropdownPage01 .checkList02 h4").next("div").removeAttr("style");
      }
    }, 200);
  });
  $(".dropdownPage01 .checkList02 h4").click(function () {
    if ($(window).width() < 640) {
      $(this).next("div").slideToggle();
      $(this).toggleClass("open");
    }
  });
});

// checkbox
$(function () {
  $(
    ".corpContents06 .contactForm02 ul li input:checked,.corpContents06 .contactForm02 table td input:checked,.checkList01 dd input:checked,.checkList01 td input:checked,.checkList02 section dd input:checked,.checkbox dd input:checked,.checkbox td input:checked,.cmnForm01 section dd input:checked"
  )
    .parent()
    .parent()
    .css("background", "#fef7dd");
  $(
    ".corpContents06 .contactForm02 ul li input,.corpContents06 .contactForm02 table td input,.checkList01 dd input,.checkList01 td input,.checkList02 section dd input,.checkbox dd input,.checkbox td input,.cmnForm01 section dd input"
  ).click(function (e) {
    var t = e.target.type;
    var chk = $(this).prop("checked");
    var name = $(this).attr("name");
    if (t == "checkbox") {
      if (chk == true) {
        $(this).parent().parent().css("background", "#fef7dd");
      } else {
        $(this).parent().parent().css("background-color", "");
      }
      return true;
    } else if (t == "radio") {
      if (chk == true) {
        $("input[name=" + name + "]")
          .parent()
          .parent()
          .css("background-color", "");
        $(this).parent().parent().css("background", "#fef7dd");
      }
      return true;
    }
  });
});

// pagetop
$(function () {
  var showTop = 100;

  var fixedTop = $(".pagetop");
  fixedTop.on("click", function () {
    $("html,body").animate({ scrollTop: "0" }, 500);
  });
  $(window).on("load scroll resize", function () {
    if ($(window).scrollTop() >= showTop) {
      fixedTop.fadeIn("normal");
    } else if ($(window).scrollTop() < showTop) {
      fixedTop.fadeOut("normal");
    }
  });
});

// answer
$(document).ready(function () {
  $(".btnSearchAddClose01")
    .click(function () {
      $(this).next().slideToggle("fast");
    })
    .next()
    .hide();
});

$(document).ready(function () {
  $(".btnSearchAddOpen01")
    .addClass("active")
    .click(function () {
      $(this).toggleClass("active").next().slideToggle("fast");
      return false;
    });
});

// closeup
$(document).ready(function () {
  $(".closeUpSlider01").bxSlider({
    auto: true,
    //		speed: 800
    speed: 3200,
  });
});
